import { redirect } from '@tanstack/react-router'
import { isAuthenticated, pb } from './pocketbase'

export const requireAuth = () => ({
  beforeLoad: ({ location }: { location: { href: string } }) => {
    const authenticated = isAuthenticated()
    console.log('🔐 Auth Guard Check:', {
      path: location.href,
      isAuthenticated: authenticated,
      action: authenticated ? 'allowing' : 'redirecting to sign-in'
    })
    
    if (!authenticated) {
      console.log('❌ Redirecting to sign-in from:', location.href)
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }
    
    console.log('✅ Auth check passed, proceeding to route')
  },
})

export const requireGuest = () => ({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})

export const requireCompleteProfile = () => ({
  beforeLoad: ({ location }: { location: { href: string } }) => {
    const authenticated = isAuthenticated()

    if (!authenticated) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }

    // Check if user has completed their profile (has birthdate and gender)
    const user = pb.authStore.model
    if (user && (!user.birthdate || !user.gender)) {
      console.log('❌ User missing profile data, redirecting to complete-profile')
      throw redirect({
        to: '/complete-profile',
      })
    }

    console.log('✅ Auth and profile check passed, proceeding to route')
  },
})